import { render, staticRenderFns } from "./advancedtable.vue?vue&type=template&id=9c2fef78&"
import script from "./advancedtable.vue?vue&type=script&lang=js&"
export * from "./advancedtable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports